// extracted by mini-css-extract-plugin
export default {"wrapper":"RandomDuck_wrapper__7oYSJ","glowing-button-85":"RandomDuck_glowing-button-85__5fHJ+"};